import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FAQSliceState, IArticle, IFAQSearchResult } from "./types";
import { requestServise } from "@/shared";
import { revertAll } from "@/app/model/actions";

const initialState: FAQSliceState = {
  error: null,
  isLoading: false,
  sectionTypes: [],
  articles: [],
  searchResult: [],
  selectedForEditItem: null,
};

/**Получение списка типов секций*/
export const fetchSectionTypes = requestServise.get<string[]>(
  "faq/sectionTypes",
  "kb/section-types",
);

/* Получение статей */
export const fetchArticles = requestServise.get<
  { articles: IArticle[] },
  string
>("kb/articles", (query: string) => `kb/articles?sectionName=${query}`);

/* Удаление конструктора из статьи */
export const deleteConstructor = requestServise.deleteWithBody<
  unknown,
  { constructorId: string; articleId: string }
>(
  "kb/deleteConstructor",
  (body) => `kb/articles/${body.articleId}/constructors`,
);

/* Создание статьи */
export const createArticle = requestServise.post<
  unknown,
  { title: string; sectionType: string }
>("kb/createArticle", "kb/articles");

/* Удаление статьи */
export const deleteArticle = requestServise.deleteWithBody<unknown, string>(
  "kb/deleteArticle",
  (query) => `kb/articles/${query}`,
);

/**Запрос поиска */
export const searchFAQ = requestServise.get<IFAQSearchResult[], string>(
  "kb/searchFAQ",
  (query: string) => `kb/search?term=${query}`,
);

export const editArticle = requestServise.put<
  unknown,
  { query: string; title: string; sectionType: string }
>("kb/editArticle", (body) => `kb/articles/${body.query}`);

export const faqSlice = createSlice({
  name: "faq",
  initialState,
  reducers: {
    setSelectedForEditItem(state, action: PayloadAction<IArticle>) {
      state.selectedForEditItem = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(revertAll, () => initialState);

    builder.addCase(fetchSectionTypes.pending, (state) => {
      state.error = null;
      state.isLoading = true;
    });
    builder.addCase(fetchSectionTypes.fulfilled, (state, action) => {
      state.sectionTypes = action.payload;
      state.isLoading = false;
    });
    builder.addCase(fetchSectionTypes.rejected, (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    });

    builder.addCase(searchFAQ.pending, (state) => {
      state.error = null;
      state.isLoading = true;
    });
    builder.addCase(searchFAQ.fulfilled, (state, action) => {
      state.searchResult = action.payload;
      state.isLoading = false;
    });
    builder.addCase(searchFAQ.rejected, (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    });

    builder.addCase(createArticle.pending, (state) => {
      state.error = null;
      state.isLoading = true;
    });
    builder.addCase(createArticle.fulfilled, (state) => {
      state.isLoading = false;
      state.error = null;
    });
    builder.addCase(createArticle.rejected, (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    });

    builder.addCase(editArticle.pending, (state) => {
      state.error = null;
      state.isLoading = true;
    });
    builder.addCase(editArticle.fulfilled, (state) => {
      state.isLoading = false;
      state.error = null;
    });
    builder.addCase(editArticle.rejected, (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    });

    builder.addCase(deleteArticle.pending, (state) => {
      state.error = null;
      state.isLoading = true;
    });
    builder.addCase(deleteArticle.fulfilled, (state) => {
      state.isLoading = false;
      state.error = null;
    });
    builder.addCase(deleteArticle.rejected, (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    });

    builder.addCase(deleteConstructor.pending, (state) => {
      state.error = null;
      state.isLoading = true;
    });
    builder.addCase(deleteConstructor.fulfilled, (state) => {
      state.isLoading = false;
      state.selectedForEditItem = null;
      state.error = null;
    });
    builder.addCase(deleteConstructor.rejected, (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    });

    builder.addCase(fetchArticles.pending, (state) => {
      state.error = null;
      state.isLoading = true;
    });
    builder.addCase(
      fetchArticles.fulfilled,
      (state, action: PayloadAction<{ articles: IArticle[] }>) => {
        state.articles = action.payload?.articles;
        state.isLoading = false;
      },
    );
    builder.addCase(fetchArticles.rejected, (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    });
  },
});

export const { setSelectedForEditItem } = faqSlice.actions;
export default faqSlice.reducer;
